import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/app/admin/lms/collections")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
